var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
'x': '0px',
'y': '0px',
'viewBox': '0 0 120 120',
'xmlSpace': 'preserve',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <polygon fill=\"#BCBBBB\" points=\"84.4,93.8 84.4,70.6 92.1,70.6 92.1,101.5 22.6,101.5 22.6,70.6 30.3,70.6 30.3,93.8 \"/> <path fill=\"#F48023\" d=\"M38.8,68.4l37.8,7.9l1.6-7.6l-37.8-7.9L38.8,68.4z M43.8,50.4l35,16.3l3.2-7l-35-16.4L43.8,50.4z M53.5,33.2 l29.7,24.7l4.9-5.9L58.4,27.3L53.5,33.2z M72.7,14.9l-6.2,4.6l23,31l6.2-4.6L72.7,14.9z M38,86h38.6v-7.7H38V86z\"/> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/stack-overflow.svg